import axios from "axios";

// Same-origin proxy backend (forwards /api/* to the shared Med Hat backend, avoiding CORS).
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("session_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const NO_REDIRECT = ["/auth/me", "/auth/login", "/auth/register", "/auth/session"];

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err.config?.url || "";
    if (err.response?.status === 401) {
      localStorage.removeItem("session_token");
      const skip = NO_REDIRECT.some((u) => url.includes(u));
      if (!skip && !window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const formatPrice = (cents) => `$${((cents || 0) / 100).toFixed(2)}`;

export default api;
